import { ACTIONS } from '../Constants';

const initialState = {
    byId: {},
    byCouponId: {}
};

const coupons = (state = initialState, action) => {
    let newById;
    let newByCouponId;
    let reducedById;
    let reducedByCouponId;
    let coupon;

    switch (action.type) {
        case ACTIONS.GET_MANY_COUPONS: {
            const { coupons = [] } = action.payload;

            reducedById = {};
            reducedByCouponId = {};

            coupons.forEach((item) => {
                reducedById[item._id] = item;
                reducedByCouponId[item.couponId] = item;
            });

            newById = {
                ...state.byId,
                ...reducedById
            };

            newByCouponId = {
                ...state.byCouponId,
                ...reducedByCouponId
            };

            return {
                ...state,
                byId: newById,
                byCouponId: newByCouponId
            };
        }
        case ACTIONS.GET_COUPON:
        case ACTIONS.POST_COUPON_SUCCESS: {
            ({ coupon } = action.payload);
            newById = {
                ...state.byId,
                [coupon._id]: coupon
            };
            newByCouponId = {
                ...state.byCouponId,
                [coupon.couponId]: coupon
            };

            return {
                ...state,
                byId: newById,
                byCouponId: newByCouponId
            };
        }

        default:
            return state;
    }
};

export default coupons;
